import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'circle-chevron-right',
  'IconCircleChevronRight',
  [
    ['path', { d: 'M11 9l3 3l-3 3', key: 'svg-0' }],
    ['path', { d: 'M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0z', key: 'svg-1' }],
  ],
);
